<mat-form-field [appearance]="appearance">
  <mat-label>{{ label }}<span class="asterisk" *ngIf="isRequired">*</span></mat-label>
  <mat-select [formControl]="inputFormControl"
    [compareWith]="options.valueMode === 'id' ? compareTransportCompanyIds : compareTransportCompanies"
    [disabled]="isDisabled">
    <mat-option *ngIf="options.emptyOptionLabel" [value]="null">{{ options.emptyOptionLabel }}</mat-option>
    <mat-option *ngFor="let transportCompany of transportCompanies" [value]="getOptionValue(transportCompany)">
      {{ transportCompany.name }}
    </mat-option>
  </mat-select>
  <mat-error *ngIf="inputFormControl?.errors?.required">
    {{ utils.giveMessageError('MANDATORY_FIELD') }}
  </mat-error>
</mat-form-field>
